import React from 'react';
import { TFunction } from 'i18next';
import {
  BusinessBalanceIcon,
  BusinessQuickNavIcon,
  FolderIcon,
  InvoicesIcon,
  MainSectionIcon,
  MyAdsIcon,
  PackagesIcon,
  Profile2Icon,
  TransactionsIcon,
  WalletIcon,
} from '@/components/UI/Icons/Icons';
import { ROUTES } from '@/constants/routes';
import { AdStatus } from '@/types';

export const MY_ADS_PATHS = [
  ROUTES.profileAds(AdStatus.Published),
  ROUTES.profileAds(AdStatus.Pending),
  ROUTES.profileAds(AdStatus.AwaitingPayment),
  ROUTES.profileAds(AdStatus.Expired),
  ROUTES.profileAds(AdStatus.Rejected),
  ROUTES.profileAds(AdStatus.Archived),
];

function getMainProfileNavItem(t: TFunction, isShop: boolean) {
  return {
    title: t(
      isShop ? 'pages.cabinet.personal_cabinet' : 'pages.cabinet.my_ads'
    ),
    href: ROUTES.profileAds(AdStatus.Published),
    icon: isShop ? (
      <MainSectionIcon data-testid="main-section-icon" />
    ) : (
      <MyAdsIcon />
    ),
  };
}

export const getGeneralProfileNavItems = (t: TFunction, isShop: boolean) => [
  getMainProfileNavItem(t, isShop),
  {
    title: t('pages.cabinet.operations_history'),
    href: ROUTES.accountTxs,
    icon: <TransactionsIcon />,
  },
  {
    title: t('pages.cabinet.my_cards'),
    href: ROUTES.cards,
    icon: <WalletIcon />,
  },
  {
    title: t('pages.cabinet.limits'),
    href: ROUTES.limits,
    icon: <FolderIcon />,
  },
];

export const getProfileSettingsNavItem = (t: TFunction) => ({
  title: t('pages.cabinet.profile'),
  href: ROUTES.settings,
  icon: <Profile2Icon />,
});

export const getBusinessProfileNavItems = (t: TFunction) => [
  {
    title: t('pages.cabinet.packages'),
    href: ROUTES.businessPackages,
    icon: <PackagesIcon />,
  },
  {
    title: t('pages.cabinet.balance'),
    href: ROUTES.businessBalance,
    icon: <BusinessBalanceIcon />,
  },
  {
    title: t('pages.cabinet.invoices'),
    href: ROUTES.businessInvoices,
    icon: <InvoicesIcon />,
  },
];

export const getMobileProfileMenuItems = (t: TFunction, isShop: boolean) => [
  ...getGeneralProfileNavItems(t, isShop),
  ...(isShop ? getBusinessProfileNavItems(t) : []),
  getProfileSettingsNavItem(t),
];

export const getMobileProfileQuickNavItems = (
  t: TFunction,
  isShop: boolean
) => [
  ...(isShop
    ? [
        {
          title: t('pages.cabinet.business'),
          href: ROUTES.businessPackages,
          icon: <BusinessQuickNavIcon data-testid="business-quick-nav-icon" />,
        },
      ]
    : []),
  {
    title: t('pages.cabinet.operations_history'),
    href: ROUTES.accountTxs,
    icon: <TransactionsIcon />,
  },
  {
    title: t('pages.cabinet.my_cards'),
    href: ROUTES.cards,
    icon: <WalletIcon />,
  },
  {
    title: t('pages.cabinet.limits'),
    href: ROUTES.limits,
    icon: <FolderIcon />,
  },
];
